import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Modal, Paper, Button } from "@material-ui/core";

const InfoPaper = styled(Paper)`
    height: 80%;
    overflowy: scroll;
    overflowx: hiddenl;
    position: relative;
`;
const InfoModal = styled(Modal)`
    width: 70vw;
    height: 80vh;
    margin-top: 10vh;
    margin-right: 15vw;
    margin-left: 15vw;
    margin-bottom: 10vh;
`;

const InfoDiv = styled.div`
    display: flex;
    justify-content: end;
    padding: 30px;
`;
const ControlInfo = (props) => {
    const [open, setOpen] = useState(props.open);
    const [info, setInfo] = useState(props.info);
    useEffect(() => {
        setOpen(props.open);
        setInfo(props.info);
    }, [props.open, props.info]);

    return (
        <InfoModal open={open}>
            <InfoPaper>
                <InfoDiv>
                    <img
                        src={info.img}
                        alt={"alt"}
                        style={{
                            marginRight: "3vw",
                            height: 275,
                            width: "auto",
                        }}
                    />
                    <div>{info.text}</div>
                </InfoDiv>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        setOpen(false);
                    }}
                    style={{
                        position: "absolute",
                        bottom: 24,
                        left: 24,
                    }}
                >
                    Close
                </Button>
            </InfoPaper>
        </InfoModal>
    );
};

export default ControlInfo;
